module.exports = __webpack_public_path__ + "fef27211e22e2921ee02cbdcf48cf188.pdf";